/*TODO: silinecek yada admin yetkisi kontrolü eklenecek!*/
function switchType() {
    if(location.href.indexOf('/junior/') === -1) {
        location.href = location.href.replace('/teenage/', '/junior/');
    }
    else {
        location.href = location.href.replace('/junior/', '/teenage/');
    }
}

function redirect(location, bool) {
    $('body').addClass('loading');
    if(!location) { return window.location.reload(); }
    location = location.replace(/^\/|\/$/g, '');
    if(bool) {
        window.location = location;
    }
    else {
        window.location = App.url + '/' + location;
    }
}

/**
 *
 * Example usage
 *
 animateCSS('.my-element', 'bounce')
 animateCSS('.my-element', 'bounce', function() {
        // Do something after animation
     })
 * */
function animateCSS(element, animationName, callback) {
    let node;
    if(element instanceof jQuery) {
        node = element[0];
    }
    else if(element instanceof HTMLElement) {
        node = element;
    }
    else {
        node = document.querySelector(element);
    }

    if(node) {
        node.classList.add('animated', animationName);

        function handleAnimationEnd() {
            node.classList.remove('animated', animationName);
            node.removeEventListener('animationend', handleAnimationEnd);

            if(typeof callback === 'function') {
                callback();
            }
        }

        node.addEventListener('animationend', handleAnimationEnd);
    }
}

function sendToSpielSpass() {
    redirect(App.type + '/spiel-spass/', false);
}

function getParams(url) {
    if(!url) {
        url = window.location.href;
    }
    let params = {};
    let parser = document.createElement('a');
    parser.href = url;
    let query = parser.search.substring(1);
    let vars = query.split('&');
    for(let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
    }
    if(Object.keys(params).length === 1 && params[''] === 'undefined') {
        return {};
    }
    return params;
}

function checkForLength(string, len) {
    if(string.length > len) {
        return string.trim().substr(0, len - 3) + '...';
    }
    return string;
}

function stringSort(elem1, elem2, keyToSearchFromElems) {
    let alphabets = [
        'A',
        'B',
        'C',
        'Ç',
        'D',
        'E',
        'F',
        'G',
        'Ğ',
        'H',
        'I',
        'İ',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'Ö',
        'P',
        'R',
        'S',
        'Ş',
        'T',
        'U',
        'Ü',
        'V',
        'Y',
        'Z',
    ];
    return function CharCompare(a, b, index) {
        if(index === a[keyToSearchFromElems].length || index === b[keyToSearchFromElems].length) {
            return 0;
        }
        var aChar = alphabets.indexOf(a[keyToSearchFromElems].toUpperCase().charAt(index));
        var bChar = alphabets.indexOf(b[keyToSearchFromElems].toUpperCase().charAt(index));
        if(aChar !== bChar) {
            return aChar - bChar;
        }
        else {
            return CharCompare(a, b, index + 1);
        }
    }(elem1, elem2, 0);
}

function scrollListener(e) {
    var element = this;
    resetTriggers(this);
    if(this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
    }
    this.__resizeRAF__ = requestFrame(function() {
        if(checkTriggers(element)) {
            element.__resizeLast__.width = element.offsetWidth;
            element.__resizeLast__.height = element.offsetHeight;
            element.__resizeListeners__.forEach(function(fn) {
                fn.call(element, e);
            });
        }
    });
}

function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function updateUserSession() {
    let token = document.head.querySelector('meta[name="csrf-token"]');
    let headers = new Headers({
        'Content-Type': 'x-www-form-urlencoded'
    });

    if(token.content) {
        headers.append('X-CSRF-TOKEN', token.content);
    }

    fetch('/session', { method: 'POST', headers });
}

function updateUserSessionInEveryMinute() {
    setInterval(updateUserSession, 60 * 1000);
}

export {
    switchType,
    redirect,
    animateCSS,
    sendToSpielSpass,
    getParams,
    checkForLength,
    stringSort,
    scrollListener,
    validateEmail,
    updateUserSession,
    updateUserSessionInEveryMinute,
};
